import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchMemoriesApi, fetchMemorySettingsApi, updateMemorySettingsApi } from '../../api/memory.api';

const emptySettings = {
  memoryEnabled: false,
  personality: 'default',
  customInstructions: '',
  toneTags: [],
  preferredName: '',
  job: '',
  interests: '',
  memorySummary: '',
  memorySummaryUpdatedAt: null
};

const initialState = {
  settings: emptySettings,
  memories: [],
  loading: false,
  saving: false,
  error: null
};

export const fetchMemorySettings = createAsyncThunk('memory/fetchSettings', async () => fetchMemorySettingsApi());

export const patchMemorySettings = createAsyncThunk('memory/patchSettings', async (patch) => updateMemorySettingsApi(patch));

export const fetchMemories = createAsyncThunk('memory/fetchMemories', async () => fetchMemoriesApi());

const memorySlice = createSlice({
  name: 'memory',
  initialState,
  reducers: {
    clearMemoryError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemorySettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemorySettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = { ...emptySettings, ...action.payload };
      })
      .addCase(fetchMemorySettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load memory settings.';
      })
      .addCase(patchMemorySettings.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(patchMemorySettings.fulfilled, (state, action) => {
        state.saving = false;
        state.settings = { ...emptySettings, ...action.payload };
      })
      .addCase(patchMemorySettings.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error.message || 'Failed to save memory settings.';
      })
      .addCase(fetchMemories.fulfilled, (state, action) => {
        state.memories = action.payload;
      });
  }
});

export const { clearMemoryError } = memorySlice.actions;
export const selectMemorySettings = (state) => state.memory.settings;
export default memorySlice.reducer;
